module.exports = __webpack_public_path__ + "static/pgp_logo-884eaa314a62ae825f115e9a227c816f.webp";